import { useIntl } from '@jetshop/intl'
import React from 'react'
import InputWithLabel from '../../../Forms/InputWithLabelVB'
import { FormFieldRow } from '../SignUpForm'

export default function PrivateCustomerFields({ requiredHint }) {
   const t = useIntl()

   const lblFirst = t('First name')
   const lblLast = t('Surname')
   const lblMobile = t('Mobile phone number')
   const lblEmail = t('E-mail address')
   const lblPassword = t('Desired password')

   return (
      <>
         <FormFieldRow
            fieldId="firstName"
            labelText={lblFirst}
            requiredHint={requiredHint}
         >
            <InputWithLabel
               hideLabel
               smallField
               name="firstName"
               type="text"
               label={lblFirst}
               placeholder={lblFirst}
            />
         </FormFieldRow>
         <FormFieldRow
            fieldId="lastName"
            labelText={lblLast}
            requiredHint={requiredHint}
         >
            <InputWithLabel
               hideLabel
               smallField
               name="lastName"
               type="text"
               label={lblLast}
               placeholder={lblLast}
            />
         </FormFieldRow>
         <FormFieldRow
            fieldId="mobilePhone"
            labelText={lblMobile}
            requiredHint={requiredHint}
         >
            <InputWithLabel
               hideLabel
               smallField
               name="mobilePhone"
               type="tel"
               label={lblMobile}
               placeholder={lblMobile}
            />
         </FormFieldRow>
         <FormFieldRow
            fieldId="emailAddress"
            labelText={lblEmail}
            requiredHint={requiredHint}
         >
            <InputWithLabel
               hideLabel
               smallField
               name="emailAddress"
               type="email"
               label={lblEmail}
               placeholder={lblEmail}
            />
         </FormFieldRow>
         <FormFieldRow
            fieldId="password"
            labelText={lblPassword}
            requiredHint={requiredHint}
         >
            <InputWithLabel
               hideLabel
               smallField
               name="password"
               type="password"
               label={lblPassword}
               placeholder={lblPassword}
            />
         </FormFieldRow>
      </>
   )
}
